export interface ModelItem {
    imageUrl: string;
    name: string;
    type: ModelItemType;
    config: string | null;
}

export enum ModelItemType {
    MAIN,
    TEMPLATES,
}

export type ModelItemsMap = { [key: string]: Array<ModelItem | null> };
